<template>
    <input
        class="input-field"
        :placeholder="placeholder"
        v-model="input"
        @change="inputChanged"
    />
</template>

<script>
export default {
    name: "FilterInputComponent",
    props: {
        placeholder: {},
    },
    data(){
        return {
            name: "",
            input: ""
        }
    },
    methods:{
        inputChanged(){
            const output = {
                "field": this.placeholder,
                "value":this.input
            }
            this.$emit('updateInputFilter', JSON.stringify(output))
        }
    }
}
</script>

<style lang="scss" scoped>
    .input-field{
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergyReportComponents/FilterInputComponent.vue